import { captureException, captureMessage, init } from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { CaptureContext } from '@sentry/types';

import { AppConfigContextProps } from '@config/get-app-config';
import { ENVS } from '@utilities/constants';

const dsn = 'https://b20833e6352c497689c556a98201dd0e@o354215.ingest.sentry.io/6090936';

const release = process.env.RELEASE ?? '';

export const initializeSentry = ({ site, environment }: AppConfigContextProps) => {
  init({
    dsn,
    beforeSend(event, hint) {
      event.contexts = {
        ...event.contexts,
        appState: {
          timestamp: new Date().toISOString(),
          windowSize: `${window.innerWidth}x${window.innerHeight}`,
        },
      };

      const stackFrames = event.exception?.values?.[0]?.stacktrace?.frames || [];
      const topFrame = stackFrames.length > 0 ? stackFrames[stackFrames.length - 1] : null;

      event.extra = {
        ...event.extra,
        hint: JSON.stringify(hint, null, 2),
        topCallStack: topFrame
          ? {
              filename: topFrame.filename || 'unknown',
              function: topFrame.function || 'anonymous',
              lineno: topFrame.lineno || 'unknown',
              colno: topFrame.colno || 'unknown',
              in_app: topFrame.in_app || false,
            }
          : 'no top frame available',
      };

      return event;
    },
    integrations: [new Integrations.BrowserTracing()],
    sampleRate: 1, // need to tweak for deployments
    tracesSampleRate: environment === ENVS.PROD ? 0.05 : 0,
    environment: environment,
    debug: false,
    release,
    initialScope: {
      tags: {
        domain: site.domain ?? 'undefined',
      },
    },
  });
};

export const logError = (error: unknown, errorContext?: CaptureContext) => {
  captureException(error, errorContext);
};

export const logMessage = (message: string, messageContext?: CaptureContext) => {
  captureMessage(message, messageContext);
};
